import fileDownload from 'js-file-download'
import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Facility, Sku } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from 'src/services/skuit/types'

export interface ExportProps {
  fields: string[],
  exportFilters?: ExportFilters,
}
class SkusAPI {
  api: API
  key = 'facility'

  constructor(api: API) {
    this.api = api
  }

  list = async (guid: string, config: CustomAxiosConfig = {}) => {
    const response = await this.api.get(`/logistics/facilities/${guid}/skus`, config)
    response.data = paginatedTransform(Sku)(response.data)
    return response.data
  }
}

export class Facilities {
  api: API
  key = 'facility'

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}) => {
    const response = await this.api.get('/logistics/facilities', config)
    response.data = paginatedTransform(Facility)(response.data)
    return response.data
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Facility> => {
    const response = await this.api.get(`/logistics/facilities/${guid}`, config)
    return rawTransform(Facility)(response.data)
  }

  selectFacility(facility?: Facility | null) {
    localStorage.setItem('global-facility-filter', facility ? (facility.guid as string) : '')
  }

  getSelectedFacility() {
    return localStorage.getItem('global-facility-filter')
  }

  export = async ({ fields }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: '/logistics/facilities/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'facilities.csv')
  }

  get skus() {
    const api = new SkusAPI(this.api)
    Object.defineProperty(this, 'skus', { value: api })
    return api
  }
}
